import { IdentityGroupAri, IdentityTeamAri } from '@atlassian/ari';

const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
const USER_ARI_PREFIX = 'ari:cloud:identity::user/';
const GROUP_ARI_PREFIX = 'ari:cloud:identity::group/';
const ORG_ARI_PREFIX = 'ari:cloud:platform::org/';

/**
 * Strips the ari prefix from a team ari if the string is the team ari format, otherwise returns the string as is.
 */
export function stripTeamARI(teamIdOrAri: string): string {
	return teamIdOrAri?.startsWith(TEAM_ARI_PREFIX)
		? teamIdOrAri.replace(TEAM_ARI_PREFIX, '')
		: teamIdOrAri;
}

/**
 * Converts a team id to a team ari.
 */
export function teamIdToAri(teamId: string): string {
	if (IdentityTeamAri.check(teamId)) {
		return teamId;
	}
	return IdentityTeamAri.create({ teamId }).toString();
}

/**
 * Strips the ari prefix from a user ari if the string is the user ari format, otherwise returns the string as is.
 */
export function stripUserARI(userIdOrAri: string): string {
	return userIdOrAri?.startsWith(USER_ARI_PREFIX)
		? userIdOrAri.replace(USER_ARI_PREFIX, '')
		: userIdOrAri;
}

export function userIdToAri(userId: string): string {
	return USER_ARI_PREFIX + userId;
}

/**
 * Converts a group id to a group ari.
 */
export function groupIdToAri(groupId: string): string {
	if (groupId.startsWith(GROUP_ARI_PREFIX)) {
		return groupId;
	}
	try {
		return IdentityGroupAri.create({ groupId }).toString();
	} catch {
		return groupId;
	}
}

/**
 * Creates an organization ARI from an organization ID.
 */
export function orgIdToAri(orgId: string): string {
	return ORG_ARI_PREFIX + orgId;
}

/**
 * Strips the ari prefix from an organization ari if the string is the organization ari format, otherwise returns the string as is.
 */
export function stripOrgARI(orgIdOrAri: string): string {
	return orgIdOrAri?.startsWith(ORG_ARI_PREFIX)
		? orgIdOrAri.replace(ORG_ARI_PREFIX, '')
		: orgIdOrAri;
}
